import React, { FC } from "react";
import { Step as RCStep } from "rc-steps";
import { StepProps as RCStepProps } from "rc-steps/es/Step";
import cn from "classnames";

const Step: FC<RCStepProps> = ({ className, ...props }) => {
  return <RCStep className={cn(className)} {...props} />;
};

export default Step;
